import { Routes, Route } from "react-router-dom";
import Users from "./Pages/Users";


export default function Rotes() {
  return (
    <Routes>
      <Route path="/" element={<Users />} />
    </Routes>
  );
}
